export const textQuienesSomos = {
    titleQuienesSomos1: "¿Quiénes",
    titleQuienesSomos2: "somos?",
    textQuienesSomosDescripcion1:
        "Somos un equipo interdisciplinario de médicos especialistas comprometidos con el bienestar y la salud de nuestros usuarios. A través de HeyDoctor, ofrecemos nuestra experiencia y conocimientos médicos de manera gratuita, brindando respuestas claras, confiables y accesibles a todas las preguntas de salud.",
    textQuienesSomosDescripcion2:
        "Nuestro objetivo es hacer que la atención médica esté más cerca de ti, a través de una plataforma fácil de usar, donde puedes consultar a médicos de diferentes especialidades sin costo alguno. Creemos que la salud debe ser accesible para todos, y estamos aquí para ayudarte a encontrar las respuestas que necesitas.",
    titleAcercaDeHeyDoc1: "Acerca de",
    titleAcercaDeHeyDoc2: "Hey Doctor",
    textAcercaDeHeyDoc: "¿Tienes dudas sobre cómo funciona nuestra plataforma? Encuentra aquí las respuestas que necesitas.",
    textAcercaDeHeyDocPreguntas: [
        {
            textPregunta: "¿Qué costo tiene la asesoría médica?",
            textRespuesta: "HeyDoctor es completamente gratuito, la asesoría médica no tiene ningún costo para tí. Las veces que sean, en el momento que sea necesario… estamos para ayudarte.",
        },
        {
            textPregunta: "¿En cuánto tiempo recibiré una respuesta acerca de mi consulta médica?",
            textRespuesta: "La respuesta la recibirá a más tardar en 24 hrs.",
        },
        {
            textPregunta: "¿Qué vías de comunicación podré tener con HeyDoctor?",
            textRespuesta:
                "Podrás consultarnos vía el chat de nuestra página web o por whatsapp. Además, podrás consultar el historial de tu chat con el médico, para cualquier duda que puedas llegar a tener.",
        },
        {
            textPregunta: "¿En qué horarios y qué días podré hacer consultas?",
            textRespuesta:
                "HeyDoctor es una plataforma disponible los 365 días del año, si no tenemos médicos conectados al momento de realizar su pregunta, el siguiente médico disponible la contestará lo más pronto posible.",
        },
        {
            textPregunta: "¿En qué ciudades operan?",
            textRespuesta: "HeyDoctor te asesora en toda la República Mexicana te encuentres.",
        },
        {
            textPregunta: "¿Qué pasa si requiero atención personalizada y presencial para mi padecimiento?",
            textRespuesta:
                "Los médicos de HeyDoctor te guían en todos lo pasos necesarios para resolver tu problema y te pueden recomendar con médico e instituciones de confianza a donde acudir a recibir atención médica presencial.",
        },
        {
            textPregunta: "¿Qué médicos son los que atienden mis consultas?",
            textRespuesta: "Medicos cirujanos con cédula profesional.",
        },
        {
            textPregunta: "¿Mis datos y mis preguntas son confidenciales?",
            textRespuesta:
                "Si, los datos que nos comparte solo tiene acceso usted y el médico que lo asesora, la información que nos comparte y se le solicita es con el objetivo de asesorar y guíar las diferentes acciones para la resolución de su problema de salud.",
        },
    ],
};
